// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function(fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export const dateFromStr = function (value) {
  let arr = value.split(' ')
  let date = arr[0].split('-')
  return new Date(date[0], date[1] - 1, date[2])
}

export const dateTimeFromStr = function (value) {
  let arr = value.split(' ')
  let date = arr[0].split('-')
  let time = arr[1].split(':')
  return new Date(date[0], date[1] - 1, date[2], time[0], time[1], time[2])
}

// 获取起始和结束日期(返回包含起始和结束日期数组)
export const getBeginAndEndDate = function (beginDate, diffSeconds) {
  // 获取起始和结束日期
  let dates = []
  let endDate
  if (diffSeconds >= 0) {
    endDate = new Date(beginDate.getTime() + 1000 * diffSeconds)
  } else {
    let tempDate = beginDate
    beginDate = new Date(beginDate.getTime() + 1000 * diffSeconds)
    endDate = tempDate
  }
  // 生成起始和结束日期数组
  dates[0] = new Date(beginDate.Format('yyyy-MM-dd') + ' 00:00:00')
  dates[1] = new Date(endDate.Format('yyyy-MM-dd') + ' 23:59:59')
  return dates
}

// 获取今天起始和结束日期(返回包含起始和结束日期数组)
export const getTodayBeginAndEndDate = function () {
  // 获取起始和结束日期
  let dates = []
  dates.push(new Date(new Date().setHours(0, 0, 0, 0))) // 获取当天零点的时间
  dates.push(new Date(new Date().setHours(23, 59, 59, 59)))
  return dates
}

// 获取近一周起始和结束日期(返回包含起始和结束日期数组)
export const getOneWeekBeginAndEndDate = function () {
  // 获取起始和结束日期
  let dates = []
  let beforeWeek = new Date().getTime() - 1000 * 3600 * 24 * 7 // 获取七天前的时间
  dates.push(new Date(beforeWeek))
  dates.push(new Date(new Date().setHours(23, 59, 59, 59)))
  return dates
}

// 获取近一月起始和结束日期(返回包含起始和结束日期数组)
export const getOneMonthBeginAndEndDate = function () {
  // 获取起始和结束日期
  let dates = []
  let beforeWeek = new Date().getTime() - 1000 * 3600 * 24 * 30 // 获取30天前的时间
  dates.push(new Date(beforeWeek))
  dates.push(new Date(new Date().setHours(23, 59, 59, 59)))
  return dates
}

// 获取年份
export function getYear(tYear) {
  return new Date().getFullYear()
}

// 获取月份
export function getMonth() {
  return new Date().getMonth() + 1
}

// 获取上个月份
export function getLastMonth() {
  let date = new Date()
  date.setDate(1) // 设置为本月1日
  date.setMonth(date.getMonth() - 1) // 实际减去30天
  return date.getMonth() + 1
}

// 获得本月天数
// 说明：由于JavaScript中day的范围为1~31中的值，所以设为0时会向前一天（即上月最后一天）
export function getMonthDays() {
  let date = new Date()
  let date2 = new Date(date.getFullYear(), date.getMonth() + 1, 0) // 获取本月最后一天
  return date2.getDate()
}

// 获得上月天数
export function getLastMonthDays() {
  let date = new Date()
  let date2 = new Date(date.getFullYear(), date.getMonth(), 0) // 获取上月最后一天
  return date2.getDate()
}

// 获得指定年月天数
export function getMonthDays2(year, month) {
  month -= month
  let date = new Date(year, month + 1, 0) // 获取本月最后一天
  return date.getDate()
}

// 获取昨日
export function getYestoday() {
  let date = new Date()
  date.setTime(date.getTime() - 24 * 3600 * 1000)
  return date.getDate()
}

// 获取本月第几天
export function getDayOfMonth() {
  return new Date().getDate()
}

// 获取本周第几天(周日为第一天)
export function getDayOfWeek() {
  return new Date().getDay() + 1
}

// 获取本周第几天文本(周日为第一天)
export function getDayTextOfWeek() {
  let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  return weeks[new Date().getDay()]
}

// 格式化时间差
export function formatDateDifference(oldDate, newDate, maxValueCount) {
  let time1 = new Date(oldDate).getTime()
  let time2 = new Date(newDate).getTime()
  let elapsedTime = time2 - time1 // 两个时间戳相差的毫秒数
  let valueCount = 0
  let strDateDifference = ''
  let days = Math.floor(elapsedTime / (24 * 3600 * 1000))
  if (days > 0) {
    strDateDifference = days + '天'
    ++valueCount
  }
  // 计算出小时数
  let leave1 = elapsedTime % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000))
  if (maxValueCount > valueCount) {
    strDateDifference += hours + '小时'
    ++valueCount
  }
  // 计算相差分钟数
  let leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000))
  if (maxValueCount > valueCount) {
    strDateDifference += minutes + '分钟'
    ++valueCount
  }
  // 计算相差秒数
  let leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  let seconds = Math.floor(leave3 / 1000)
  if (maxValueCount > valueCount) {
    strDateDifference += seconds + '秒'
    ++valueCount
  }

  return strDateDifference
}



// WEBPACK FOOTER //
// ./src/utils/date.js